import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
    IconCameraOutline,
    Text,
} from '@zillow/constellation';

// constants
import SelectPropertyConstants from 'app/shared/constants/SelectPropertyConstants';

// Styled Components
import {
    StyledListingStatus,
    StyledStatusMessage,
    StyledImg,
    StyledAnchor,
    StyledSelectPropertyCardContent,
    StyledPropertyItemStatus,
    StyledPhotoContainer,
    StyledCard,
} from '../StyledComponents';

const propTypes = {
    type: PropTypes.oneOf([
        'applications',
        'leases',
        'listings',
        'payments',
    ]).isRequired,
    listing: PropTypes.object.isRequired,
};

const defaultProps = {};

function SelectPropertyCard(props) {
    const { listing, type, className } = props;
    const {
        city,
        message,
        state,
        street,
        unit,
        zip,
        primaryPhotoUrl,
        urlPath,
    } = listing;

    const cityStateZip = `${city}, ${state} ${zip}`;
    const streetWithUnit = unit !== '' ? `${street}, ${unit}` : `${street}`;

    const renderPhoto = () => {
        const imageTag = (
            <StyledImg src={primaryPhotoUrl} alt="hero" />
        );

        const noPhoto = (
            <IconCameraOutline size="md" />
        );

        return (
            primaryPhotoUrl ? imageTag : noPhoto
        );
    };

    const renderSummary = () => {
        const statusClassName = cx(`Status-${type}`);
        switch (type) {
            case SelectPropertyConstants.LISTINGS:
                return (
                    <div className={statusClassName}>
                        <StyledListingStatus
                            marginRight="xs"
                            message={message}
                        />
                        <StyledStatusMessage>{message}</StyledStatusMessage>
                    </div>
                );

            // fall through
            case SelectPropertyConstants.APPLICATIONS:
            case SelectPropertyConstants.LEASES:
            case SelectPropertyConstants.PAYMENTS:
                return (
                    <div className={statusClassName}>{message}</div>
                );

            default:
                console.warn('No Case for: ', type);
                break;
        }
    };

    const escapeUrl = type !== SelectPropertyConstants.LISTINGS;
    const status = renderSummary();

    // reload page otherwise use react router Link
    const linkProps = escapeUrl ? {
        as: 'a',
        href: urlPath,
    } : {
        as: Link,
        to: urlPath,
    };

    return (
        <StyledAnchor
            className={`${className} SelectPropertyCard-Anchor`}
            {...linkProps}
        >
            <StyledCard
                mediaQuery={{ xl: { marginRight: 'md' } }}
                className="SelectPropertyCard"
                cardType="secondary"
                cardPadding={0}
            >
                <StyledPhotoContainer>
                    {renderPhoto()}
                </StyledPhotoContainer>

                <StyledSelectPropertyCardContent padding="sm">
                    {status && (
                        <StyledPropertyItemStatus
                            marginBottom="xs"
                            fontType="body"
                            as="div"
                        >
                            {status}
                        </StyledPropertyItemStatus>
                    )}

                    <div className="Property-Item-Address-Container">
                        <Text className="Property-Item-Street" fontType="bodySmall" as="div">{streetWithUnit}</Text>
                        <Text className="Property-Item-City-State-Zip" fontType="bodySmall" as="div">
                            {cityStateZip}
                        </Text>
                    </div>
                </StyledSelectPropertyCardContent>
            </StyledCard>
        </StyledAnchor>
    );
}

SelectPropertyCard.defaultProps = defaultProps;
SelectPropertyCard.propTypes = propTypes;

export { SelectPropertyCard };
export default SelectPropertyCard;
